import { create } from "zustand";
import {
  createWorkflowRunCoreSlice,
  workflowRunCoreInitialState,
  type WorkflowRunCore,
} from "src/views/products/workflow/store/createWorkflowRunStore";

interface ItemEquivalencyRunActions {
  reset: () => void;
}

/**
 * IE's instance of the shared workflow run store — what the shared
 * InputDocumentsUploader binds to on the comparison splash. One store per
 * product (never keyed/shared) so uploads staged here cannot leak into PG
 * or 50.59 on navigation.
 *
 * The uploader pre-creates the evaluation dialogue when a file is uploaded
 * ad-hoc (files need a dialogue dataset to land in); the splash then passes
 * that `dialogueId` to records/from-parts so the record attaches to the same
 * dialogue the documents live on.
 */
export const useItemEquivalencyRunStore = create<
  WorkflowRunCore & ItemEquivalencyRunActions
>()((set, get) => ({
  ...createWorkflowRunCoreSlice(set, get),
  reset: () =>
    set((state) => ({
      ...workflowRunCoreInitialState,
      // See createWorkflowRunCoreSlice: the uploader's registered function
      // must survive data resets.
      removeUploadedFile: state.removeUploadedFile,
    })),
}));
